import { FormattedText } from "@tm/static";
import type { CancelPolicyConfirmationPlanDetailsData } from "../types";
import {
  detailLabelStyle,
  detailValueStyle,
  PlanBand,
  PlanDetailLabelCell,
  PlanDetailRow,
  PlanDetailsHeader,
  planDetailsHeaderTitleStyle,
  PlanDetailsList,
  PlanIcon,
  planProviderStyle,
  PlanText,
  planTitleStyle,
} from "./CancelPolicyConfirmationPlanDetails.style";
import { StepCard } from "./CancelPolicyStepCards.style";

export const CancelPolicyConfirmationPlanDetails = ({
  header,
  planInfo,
  orderDetailsList,
}: CancelPolicyConfirmationPlanDetailsData) => {
  if (!header && !planInfo && !orderDetailsList?.length) {
    return null;
  }

  return (
    <StepCard data-testid="cancelPolicyConfirmationPlanDetails">
      {header?.title ? (
        <PlanDetailsHeader>
          <FormattedText
            value={header.title}
            baseStyle={planDetailsHeaderTitleStyle}
          />
        </PlanDetailsHeader>
      ) : null}

      {planInfo && (
        <PlanBand>
          {planInfo.icon ? (
            <PlanIcon src={planInfo.icon} alt="" aria-hidden="true" />
          ) : null}
          <PlanText>
            <FormattedText value={planInfo.title} baseStyle={planTitleStyle} />
            <FormattedText
              value={planInfo.provider}
              baseStyle={planProviderStyle}
            />
          </PlanText>
        </PlanBand>
      )}

      {orderDetailsList?.length ? (
        <PlanDetailsList>
          {orderDetailsList.map((item, index) => (
            <PlanDetailRow key={`plan-detail-${index}`}>
              <PlanDetailLabelCell>
                <FormattedText
                  value={item.label}
                  baseStyle={detailLabelStyle}
                />
              </PlanDetailLabelCell>
              <FormattedText value={item.value} baseStyle={detailValueStyle} />
            </PlanDetailRow>
          ))}
        </PlanDetailsList>
      ) : null}
    </StepCard>
  );
};

export default CancelPolicyConfirmationPlanDetails;
